import Icon from '@/components/atoms/Icon';

interface RecordingRowProps {
  id: string;
  title: string;
  label?: string;
  isOriginal?: boolean;
  showActionButton: boolean;
  isActive: boolean;
  onSelect: () => void;
}

function RecordingRow({ title, label, isActive, isOriginal, showActionButton, onSelect }: RecordingRowProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
      className="flex cursor-pointer items-center gap-2 rounded px-3 py-2.5 text-sm text-slate-700 hover:bg-slate-50"
    >
      <span className="shrink-0">
        <Icon name={isOriginal ? 'IconOriginalRecording' : 'IconCopy'} size={20} />
      </span>
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="truncate font-medium">{label ?? title}</span>
      </div>
      {showActionButton && (
        <div>
          <button disabled title="Download" className="cursor-not-allowed rounded p-1 text-slate-400 opacity-50">
            <Icon name="IconDownload" size={20} />
          </button>
          <button disabled title="Delete" className="cursor-not-allowed rounded p-1 text-slate-400 opacity-50">
            <Icon name="IconTrash" size={20} />
          </button>
        </div>
      )}
      {isActive && (
        <span className="flex w-4 shrink-0 items-center justify-center">
          <Icon name="IconCheck" size={20} />
        </span>
      )}
    </div>
  );
}

export default RecordingRow;
